import React from "react";
import { useTheme } from "styled-components";
import { getProgressCircleSizeStyles } from "./helpers";
import * as S from "./styled";
import { ProgressCircleProps } from "./types";

type CircleProps = Required<
    Pick<ProgressCircleProps, "size" | "progressColor" | "progressBackgroundColor"> & {
        progress: number;
    }
>;

/**
 * @internal
 */
const Circle = ({ size, progress, progressColor, progressBackgroundColor }: CircleProps): JSX.Element => {
    const {
        v2: { colors }
    } = useTheme();
    const { size: styleSize, strokeWidth } = getProgressCircleSizeStyles(size);

    const centerPoint: number = styleSize / 2;
    const radius: number = centerPoint - strokeWidth / 2;
    const circumference: number = 2 * Math.PI * radius;
    const completionProgress: number = circumference * ((100 - progress) / 100);

    const commonCircleProps: React.ComponentProps<typeof S.ProgressRingCircle> = {
        cx: centerPoint,
        cy: centerPoint,
        r: radius,
        $strokeWidth: strokeWidth
    };

    return (
        <S.ProgressRingSvg
            $size={styleSize}
            viewBox={`0 0 ${styleSize} ${styleSize}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <S.ProgressRingCircle {...commonCircleProps} stroke={colors[progressBackgroundColor]} />
            <S.ProgressRingCircle
                {...commonCircleProps}
                stroke={colors[progressColor]}
                strokeDasharray={circumference}
                strokeDashoffset={completionProgress}
            />
        </S.ProgressRingSvg>
    );
};

export default Circle;
